import {
  Phone,
  Email,
  LocationOn,
} from "@mui/icons-material"

export const siteContactConfig = {
  title: "Contact Information",

  phone: {
    icon: Phone,
    label: "+91 88188-88744",
    link: "tel:+918818888744",
  },

  email: {
    icon: Email,
    label: "psrco131@gmail.com",
    link: "mailto:psrco131@gmail.com",
  },

  location: {
    icon: LocationOn,
    label: "Indore, Madhya Pradesh, India",
  },

  cta: {
    text: "Call Now",
    link: "tel:+918818888744",
  },
}
